module.exports = __webpack_public_path__ + "static/media/sj.73966dcd.svg";